(function () {
  'use strict';

  var MIN_COUNT_TIME = 1.10;
  var MIN_TOTAL_TIME = 1.85;
  var COUNT_EASE = 3.6;
  var FINISH_TIME = 0.42;
  var STALL_AFTER = 1.2;

  function signalIntro() {
    window.__czardIntro = true;
    document.dispatchEvent(new Event('czard:intro'));
  }

  var root = document.getElementById('czard-loader');

  if (!root) {
    if (document.readyState === 'complete') signalIntro();
    else window.addEventListener('load', signalIntro);
    return;
  }

    if (window.CzardBoot) {
    /* DOMContentLoaded, not load. `load` waits for every subresource on the
       page — the CDN modules, the 360 viewers, and the ~23MB of scene art,
       which TextureLoader has already put in flight by then. Gating on it
       made the reveal wait for artwork the visitor cannot see yet, which is
       exactly what loadScene's own comment says it is avoiding.

       What the reveal actually needs is registered as its own task by the
       scene below; this one only guarantees the document itself is parsed. */
    window.CzardBoot.add(new Promise(function (res) {
      if (document.readyState !== 'loading') res();
      else document.addEventListener('DOMContentLoaded', res, { once: true });
    }), 'document', 2);

    // the headline and captions are drawn in Fitzgerald — revealing before it
    // lands means a visible reflow a moment later
    if (document.fonts && document.fonts.ready) {
      window.CzardBoot.add(document.fonts.ready, 'fonts', 3);
    }
  }


  function finish() {
    try { sessionStorage.setItem('czard_loaded', '1'); } catch (e) {}
    document.documentElement.classList.remove('czard-loading');
    signalIntro();
  }

  function teardown() {
    if (root.parentNode) root.remove();
    finish();
  }

  function fadeReveal() {
    if (window.gsap) {
      window.gsap.to(root, {
        autoAlpha: 0, duration: 0.6, ease: 'power2.inOut',
        onComplete: teardown
      });
    } else {
      root.style.display = 'none';
      teardown();
    }
  }

  function run() {
    var gsap = window.gsap;
    if (!gsap) { fadeReveal(); return; }

    var hasSplit = !!window.SplitText;
    var hasEase = !!window.CustomEase;
    if (hasSplit && hasEase) gsap.registerPlugin(window.SplitText, window.CustomEase);
    else if (hasSplit) gsap.registerPlugin(window.SplitText);

    if (hasEase) {
      window.CustomEase.create('smooth', '0.625, 0.05, 0, 1');
      window.CustomEase.create('smoothOut', '0.16, 1, 0.3, 1');
      window.CustomEase.create('smoothIn', '0.7, 0, 0.84, 0');
    }
    var EASE = hasEase ? 'smooth' : 'power2.inOut';
    var EASE_OUT = hasEase ? 'smoothOut' : 'power3.out';
    var EASE_IN = hasEase ? 'smoothIn' : 'power3.in';

    var counter = root.querySelector('.czl-counter');
    var counterInner = root.querySelector('.czl-counter-inner');
    var counterShift = root.querySelector('.czl-counter-shift');
    var counterValue = root.querySelector('.czl-counter-value');
    var counterUnit = root.querySelector('.czl-counter-unit');
    var topLayer = root.querySelector('.czl-top');
    var loaderImg = root.querySelector('.czl-img');
    var progress = { value: 0 };
    var clamp01 = gsap.utils.clamp(0, 1);

    var PLACES = [100, 10, 1];
    var CELLS = '01234567890';

    var digits = PLACES.map(function (place) {
      var win = document.createElement('span');
      win.className = 'czl-digit';
      var strip = document.createElement('span');
      strip.className = 'czl-strip';
      for (var i = 0; i < CELLS.length; i++) {
        var cell = document.createElement('span');
        cell.className = 'czl-cell';
        cell.textContent = CELLS.charAt(i);
        strip.appendChild(cell);
      }
      win.appendChild(strip);
      return {
        win: win,
        strip: strip,
        place: place,
        setY: gsap.quickSetter(strip, 'y', 'em'),
        setAlpha: gsap.quickSetter(win, 'opacity'),
        y: NaN,
        alpha: NaN
      };
    });

    (function mountOdometer() {
      var frag = document.createDocumentFragment();
      for (var i = 0; i < digits.length; i++) frag.appendChild(digits[i].win);
      counterValue.textContent = '';
      counterValue.appendChild(frag);
    })();

    var lastAngle = -1;
    var lastShift = null;

    function renderProgress(v) {
      var hidden = 0;

      for (var i = 0; i < digits.length; i++) {
        var dg = digits[i];
        var d = v / dg.place;
        var whole = Math.floor(d);
        var y = -Math.round(((whole % 10) + (d - whole)) * 1000) / 1000;
        var a = dg.place === 1 ? 1
              : dg.place === 10 ? clamp01((v - 9) / 1.5)
              : clamp01((v - 98) / 2);
        a = Math.round(a * 100) / 100;

        hidden += 1 - a;

        if (y !== dg.y) { dg.setY(y); dg.y = y; }
        if (a !== dg.alpha) { dg.setAlpha(a); dg.alpha = a; }
      }

      var shift = -Math.round((hidden / 2) * 1000) / 1000;
      if (shift !== lastShift) {
        counterShift.style.setProperty('--czl-shift', shift + 'ch');
        lastShift = shift;
      }

      var angle = Math.round(v * 36) / 10;
      if (angle !== lastAngle) {
        topLayer.style.setProperty('--angle', angle + 'deg');
        lastAngle = angle;
      }
    }

    var riseTargets = digits.map(function (dg) { return dg.win; }).concat([counterUnit]);

    gsap.set(counter, { autoAlpha: 1 });
    gsap.set(riseTargets, { yPercent: 110 });
    renderProgress(0);

    var intro = gsap.timeline({ defaults: { ease: EASE } });
    intro.from(loaderImg, { scale: 0.94, autoAlpha: 0, duration: 1.0, ease: EASE_OUT }, 0);
    intro.to(riseTargets, { yPercent: 0, duration: 0.8, stagger: 0.08, ease: EASE_OUT }, 0.2);

    var boot = window.CzardBoot;
    var gateOpen = !boot;
    if (boot) {
      boot.seal();
      boot.ready().then(function () { gateOpen = true; });
    }

    function now() {
      return (window.performance && performance.now) ? performance.now() : Date.now();
    }

    var t0 = now();
    var lastTick = t0;
    var lastMoveAt = t0;
    var lastMoveValue = 0;
    var waiting = false;
    var counting = true;

    var gateOpenAt = -1;
    var finishFrom = -1;
    var finishAt = 0;

    function tick() {
      if (!counting) return;

      var t = now();
      var dt = Math.min((t - lastTick) / 1000, 0.1);
      lastTick = t;
      var elapsed = (t - t0) / 1000;

      if (gateOpen && gateOpenAt < 0) gateOpenAt = elapsed;

      if (gateOpenAt >= 0 && elapsed >= Math.max(gateOpenAt, MIN_COUNT_TIME)) {
        if (finishFrom < 0) {
          finishFrom = progress.value;
          finishAt = elapsed;
          if (waiting) { waiting = false; root.classList.remove('is-waiting'); }
        }
        var k = Math.min(1, (elapsed - finishAt) / FINISH_TIME);
        var eased = k * k * (3 - 2 * k);
        progress.value = finishFrom + (100 - finishFrom) * eased;
        renderProgress(progress.value);

        if (k >= 1 && elapsed >= MIN_TOTAL_TIME) {
          counting = false;
          gsap.ticker.remove(tick);
          renderProgress(100);
          playExit();
        }
        return;
      }

      var target = boot ? boot.progress() * 100 : 100;

      if (elapsed < MIN_COUNT_TIME) {
        var ramp = (elapsed / MIN_COUNT_TIME) * 100;
        if (ramp < target) target = ramp;
      }

      progress.value += (target - progress.value) * (1 - Math.exp(-COUNT_EASE * dt));
      if (progress.value > 100) progress.value = 100;
      renderProgress(progress.value);

      if (progress.value - lastMoveValue > 0.25) {
        lastMoveValue = progress.value;
        lastMoveAt = t;
      }
      var stalled = (t - lastMoveAt) / 1000 > STALL_AFTER;
      if (stalled !== waiting) {
        waiting = stalled;
        if (stalled) root.classList.add('is-waiting');
        else root.classList.remove('is-waiting');
      }
    }

    gsap.ticker.add(tick);

    function playExit() {
      var out = gsap.timeline({ defaults: { ease: EASE } });

      out.to(counterInner, {
        yPercent: -120, autoAlpha: 0, duration: 0.6, ease: EASE_IN,
        onComplete: function () {
          for (var i = 0; i < digits.length; i++) {
            digits[i].strip.style.willChange = 'auto';
            digits[i].win.style.willChange = 'auto';
          }
          counterShift.style.willChange = 'auto';
        }
      }, 0);

      out.to(loaderImg, { scale: 1.05, autoAlpha: 0, duration: 0.9, ease: EASE_IN }, 0);

      out.add(fadeReveal, 0.8);
    }
  }

  function whenReady(cb) {
    var fired = false;
    function fire() {
      if (fired) return;
      fired = true;
      cb();
    }
    setTimeout(fire, 1500);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fire);
    else fire();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { whenReady(run); }, { once: true });
  } else {
    whenReady(run);
  }
})();
